<template>
  <div class="ms">
    <div class="ms-card">
      <div v-if="!signerInfo" class="ms-loading">
        İmzacı bilgileri alınıyor.
      </div>
      <div v-else>
        <div class="ms-row" v-if="signerInfo.User">
          <span class="ms-label">İmzacı</span>
          <span class="ms-value">{{ signerInfo.User && signerInfo.User.FullName }}</span>
        </div>
        <div class="ms-row">
          <span class="ms-label">Operatör</span>
          <span class="ms-value">{{ signerInfo.Operator }}</span>
        </div>
        <div class="ms-row">
          <span class="ms-label">Numara</span>
          <span class="ms-value">{{ signerInfo.Number }}</span>
        </div>
        <div class="ms-error" v-show="signerInfo.Error">
          <span class="material-symbols-outlined">error</span>
          <span class="ms-error-text">{{ signerInfo.Error }}</span>
        </div>
      </div>
    </div>

    <div v-if="signerInfo && item" class="ms-card">
      <div class="ms-current-name">{{ item.FileName }}</div>
      <div v-if="item.Fingerprint" class="ms-fingerprint">
        <span class="material-symbols-outlined">fingerprint</span>
        <code>{{ item.Fingerprint }}</code>
      </div>
      <div v-if="item.error" class="ms-error" role="alert">
        <span class="material-symbols-outlined">warning</span>
        <span class="ms-error-text">{{ item.error }}</span>
        <button type="button" class="ms-error-close" aria-label="Kapat" @click="dismissError">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    </div>

    <div class="ms-card ms-files">
      <div
        v-for="(i, index) in items"
        :key="i.DocumentId || i.Id || index"
        class="ms-file"
      >
        <span class="ms-file-icon"><span class="material-symbols-outlined">description</span></span>
        <div class="ms-file-main">
          <span class="ms-file-name">{{ i.FileName }}</span>
          <span class="ms-file-size">{{ i.Size | prettyBytes }}</span>
        </div>
        <span v-if="i.State" class="ms-state" :class="stateClass(i)">{{ i.State }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  props: {
    items: Array
  },
  data() {
    return {
      signerInfo: null, // İmzacı bilgileri
      jobInfo: null,     //İş bilgileri
      item: null, // Şu anda imzalanmakta olan dosya
      loading: false
    };
  },
  created() {
    axios
      .get("/mobilesign/signerinfo")
      .then(x => {
        this.signerInfo = x.data.Data;
        console.log("signerInfo:", this.signerInfo);
      })
      .catch(x => {
        this.signerInfo = {
          Error: "Mobil imza bilgileri alınamadı."
        };
        console.log("Mobil imza bilgileri alınamadı: ", x);
      });
  },
  methods: {
    stateClass(i) {
      if (i.OK === true) return "ms-state-success";
      if (i.State == "Başarısız") return "ms-state-danger";
      return "ms-state-active";
    },
    dismissError() {
      this.item.error = "";
      this.$forceUpdate();
    },
    setLoading(isLoading) {
      this.loading = isLoading;
      this.$emit("onloading", isLoading);
    },
    cancel() {
      this.canceled = true;
      this.setLoading(false);
    },
    signDocument(index) {
      this.item = this.items[index];

      this.item.State = "Parmakizi hesaplanıyor";
      this.item.error = "";

      axios
        .get(this.item.FingerprintUrl, { silent: true })
        .then(x => {
          console.log("Fingerprint result: ", x.data);
          if (x.data.Success) {
            this.item.Fingerprint = x.data.Data.Fingerprint;

            this.item.State = "İmza bekleniyor";
            this.$forceUpdate();

            var dataUrl = this.item.PostUrl.replace(
              "{0}",
              x.data?.Data?.FingerPrintTempFileId
            );
            console.log(dataUrl);

            setTimeout(() => {
              axios
                .get(dataUrl, { silent: true })
                .then(x => {
                  console.log("mobile sign result:", x.data);
                  if (x.data.Success) {
                    this.item.State = "Tamamlandı";
                    this.item.OK = true;

                    if (index + 1 < this.items.length) {
                      this.signDocument(index + 1);
                    } else {
                      this.$emit("completed", this.items);
                      this.setLoading(false);
                    }
                  }
                })
                .catch(x => {
                  console.log("Mobil imza başarısız: ", x);
                  this.item.error = x.response.data.ModelState.UserException[0];
                  this.item.State = "Başarısız";
                  this.item.Fingerprint = null;
                  this.item.OK = false;
                  this.setLoading(false);
                })
                .then(() => {
                  this.$forceUpdate();
                });
            }, 1500);
          } else {
            this.item.error = x.data.ErrorMessages;
          }
        })
        .catch(x => {
          this.item.error = x.response.data.ModelState.UserException[0];
          this.item.State = "Başarısız";
          this.setLoading(false);
          console.log("Parmak izi alınamadı: ", x);
        })
        .then(() => {
          this.$forceUpdate();
        });
    },
    sign() {
      this.setLoading(true);
      this.signDocument(0);
    }
  }
};
</script>
<style scoped>
/* Voya: mobil imza bilgileri ve dosya listesi */
.ms {
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

.ms-card {
  box-sizing: border-box;
  margin-top: 12px;
  padding: 16px;
  border: 1px solid #EFEFEF;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
}

.ms-loading {
  padding: 8px 0;
  text-align: center;
  font-size: 13px;
  color: #808080;
}

.ms-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
}

.ms-row + .ms-row {
  border-top: 1px solid #EFEFEF;
}

.ms-label {
  flex-shrink: 0;
  font-weight: 400;
  font-size: 14px;
  color: #808080;
}

.ms-value {
  min-width: 0;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  word-break: break-word;
}

.ms-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #FDECEE;
  font-size: 13px;
  line-height: 150%;
  color: #B02A37;
}

.ms-error .material-symbols-outlined {
  flex-shrink: 0;
  font-size: 20px;
}

.ms-error-text {
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
}

.ms-error-close {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: #B02A37;
}

.ms-error-close .material-symbols-outlined {
  font-size: 18px;
}

.ms-current-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #092154;
  word-break: break-all;
}

.ms-fingerprint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #F1F7FF;
  color: #182F5E;
}

.ms-fingerprint .material-symbols-outlined {
  flex-shrink: 0;
  font-size: 22px;
}

.ms-fingerprint code {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #182F5E;
  word-break: break-all;
}

.ms-files {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
}

.ms-file {
  display: flex;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  min-height: 50px;
  padding: 8px 10px;
  border: 1px solid #DCE3F2;
  border-radius: 10px;
  background-color: #F1F7FF;
}

.ms-file-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: #ffffff;
  color: #182F5E;
}

.ms-file-icon .material-symbols-outlined {
  font-size: 20px;
}

.ms-file-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.ms-file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #333333;
}

.ms-file-size {
  font-size: 12px;
  line-height: 140%;
  color: #808080;
}

.ms-state {
  flex-shrink: 0;
  max-width: 45%;
  padding: 2px 10px;
  border-radius: 100px;
  font-weight: 500;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}

.ms-state-active {
  background-color: #E5F1FF;
  color: #097DFF;
}

.ms-state-success {
  background-color: #E3F5EA;
  color: #1E9E57;
}

.ms-state-danger {
  background-color: #FDECEE;
  color: #DC3545;
}
</style>
